<template>
  <div class="flex justify-center">
    <div class="flex items-center justify-center rounded-full bg-warning-100 h-12 w-12 mb-2">
      <AlertCircle class="h-8 w-8 text-warning-400" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { AlertCircle } from 'lucide-vue-next';
</script>
